/**
 * 应用主布局
 * 侧边栏 (240px) + 内容区
 * 手机端：汉堡菜单 + Drawer 侧边栏
 */
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import Sidebar from './Sidebar';
import useIsMobile from '../hooks/useIsMobile';
import './AppLayout.css';

const AppLayout = () => {
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-layout-wrapper">
      {isMobile && (
        <div className="mobile-header">
          <button className="mobile-hamburger" onClick={() => setSidebarOpen(true)}>
            <MenuOutlined style={{ fontSize: 20 }} />
          </button>
          <span className="mobile-header-title">K-label</span>
        </div>
      )}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="app-main-content">
        <div className="app-main-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
